import React from 'react'
import './PropertyInfo.scss'
import PropTypes from 'prop-types'
import Comps from '@engine/comps'
import { connect } from 'react-redux'
import { EditPropertyDetails, EditPropertyName } from '@components/custom'
import { EditButtonWrapper } from '@components/common'
import { formatNumber } from '@engine/utils/format'
import {
  SALES_COMPARABLES,
  SH_COMPARABLES,
  propertyFieldsRent,
  propertyFieldsSales,
  propertyFieldsRentT5,
  propertyFieldsStudentHousing
} from '@engine/dependencies/constants'

export class PropertyInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      editPropNameDialog: false
    }
  }

  handlePropertyDetailsDialog = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  handleDoneDialog = data => {
    const type = this.props.propertyType.toString().includes('S') ? 'subject' : 'comparable'
    this.props.editPropertyDetails({ type, data: data.propertyFields })
  }

  editPropertyNameDialog = () => {
    this.setState({
      editPropNameDialog: !this.state.editPropNameDialog
    })
  }

  handleSavepropertyName = data => {
    const { propertyType } = this.props
    this.props.editPropertyName({ propertyType, name: data.pname, isNameModified: true })
  }

  formatValue(field, value) {
    let result = field === 'propertyAddress' ? value : formatNumber(field, value)
    if (field === 'sfBuyerAccountId' || field === 'sfSellerAccountId') {
      result = result.length >= 28 ? result.slice(0, 28).concat('..') : result
    }

    return result
  }

  render() {
    const { propertyInfo, templateName, propertyType, themeColors, propertyFields, subjectPropertyFields, isSubjectPropertyDeleted, propertyNameList } = this.props
    const isSalesTemplate = templateName.includes(SALES_COMPARABLES)
    const isSHTemplate = templateName.includes(SH_COMPARABLES)
    const displayPropertyFields = propertyType.toString().includes('S') ? subjectPropertyFields : propertyFields
    const columns_to_be_displayed = isSubjectPropertyDeleted ? displayPropertyFields.filter(col => col.key !== 'Distance') : displayPropertyFields
    const MAX_CHARS_CITY = 19
    const addressLine1Sales = propertyInfo.addressLine1?.replace(/,\s*$/, '')
    const headingStyle = propertyType?.toString().includes('S') ? {
      color: themeColors.subjectPropertyNameColor
    } : {
      color: themeColors.comparablePropertyNameColor
    }

    const propertyText = propertyType.toString().includes('S') ? 'Subject Property only' : 'all Comparable Properties'
    const contentNote = `Select none to hide labels. To change the column order, drag and drop a field, Changes will be applicable to ${propertyText}.`
    const dialogTitle = propertyType.toString().includes('S') ? 'Subject Property Labels' : 'Comparable Property Labels'
    const dialogProperties = isSalesTemplate ? propertyFieldsSales : (templateName === 'rentCompsT5' ? propertyFieldsRentT5 : (isSHTemplate ? propertyFieldsStudentHousing : propertyFieldsRent))
    dialogProperties.propertyFields = displayPropertyFields
    const fieldsDisplayStyle = isSalesTemplate || (templateName === 'rentCompsT4' || templateName === 'rentCompsT5') ? 'list-style' : 'grid-style'
    const addressLineWrappedFlag = isSalesTemplate || (templateName === 'rentCompsT4' || templateName === 'rentCompsT5')

    return (
      <>
        <div
          data-testid="property-info"
          className={isSalesTemplate ? '' : 'property-info'}
        >
          <EditButtonWrapper handleEditButtonClick={this.editPropertyNameDialog} dataTestId="edit-propertyname-icon">
            <div className="property-info__heading" style={headingStyle}>
              {propertyInfo.name}
            </div>
          </EditButtonWrapper>
          <div className="property-info__address">
            {addressLineWrappedFlag ? (
              <>
                <span>
                  {addressLine1Sales}
                </span>
                <span>
                  {propertyInfo.city.slice(0, MAX_CHARS_CITY)}, {propertyInfo.state}{' '}{propertyInfo.zipCode}
                </span>
              </>
            ) : (
              <span>
                {propertyInfo.addressLine1} {propertyInfo.city}, {propertyInfo.state}{' '}
                {propertyInfo.zipCode}
              </span>
            )}
          </div>
          <EditButtonWrapper handleEditButtonClick={this.handlePropertyDetailsDialog} dataTestId="edit-propertyDetails-icon">
            <div className={fieldsDisplayStyle}>
              {columns_to_be_displayed && columns_to_be_displayed.map((attr, index) => {
                if (propertyInfo[attr.value] && propertyInfo[attr.value] !== 'NA') {
                  return (
                    <div key={index}>
                      <div className="property-info__wrap">
                        <div className="">{attr.key}:</div>
                        <div className="property-info__wrap-dot" />
                        <div>{this.formatValue(attr.value, propertyInfo[attr.value])}</div>
                      </div>
                    </div>
                  )
                }

                return ''
              })}
            </div>
          </EditButtonWrapper>
        </div>
        {this.state.isOpen ? (
          <EditPropertyDetails
            isDialogOpen={this.state.isOpen}
            closeEditPopup={this.handlePropertyDetailsDialog}
            doneDialog={this.handleDoneDialog}
            contentNote={contentNote}
            dialogTitle={dialogTitle}
            dialogProperties={dialogProperties}
          />
        ) : ''}
        {this.state.editPropNameDialog ? (
          <EditPropertyName
            isDialogOpen={this.state.editPropNameDialog}
            closeEditPopup={this.editPropertyNameDialog}
            doneDialog={this.handleSavepropertyName}
            name={propertyInfo.name}
            dialogTitle="Edit Property Name"
            editPropertyNameDialog={this.editPropertyNameDialog}
            propertyNameList={propertyNameList}
          />
        ) : '' }
      </>
    )
  }
}

PropertyInfo.propTypes = {
  propertyInfo: PropTypes.object,
  propertyType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  themeColors: PropTypes.object,
  propertyFields: PropTypes.array,
  subjectPropertyFields: PropTypes.array,
  editPropertyDetails: PropTypes.func,
  editPropertyName: PropTypes.func,
  propertyNameList: PropTypes.array,
  templateName: PropTypes.string,
  isSubjectPropertyDeleted: PropTypes.bool
}

const mapStateToProps = state => ({
  themeColors: Comps.selectors.comps.themeColors(state),
  propertyFields: Comps.selectors.comps.propertyFields(state),
  subjectPropertyFields: Comps.selectors.comps.subjectPropertyFields(state),
  isSubjectPropertyDeleted: Comps.selectors.comps.isSubjectPropertyDeleted(state)
})

const mapDispactchToProps = {
  editPropertyDetails: Comps.actions.editPropertyDetails,
  editPropertyName: Comps.actions.editPropertyName
}

export default connect(mapStateToProps, mapDispactchToProps)(PropertyInfo)
